import axiosInstance from "../utils/axios";

export const institutionalAffiliationService = {
  fetchAllWithoutPaginate: async () => {
    const response = await axiosInstance.get("/institutional-affiliation/all");
    return response.data;
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get("/institutional-affiliation", {
      params,
    });
    return response.data;
  },
  findById: async (id) => {
    const response = await axiosInstance.get(`/institutional-affiliation/${id}`);
    return response.data;
  },
  store: async (data) => {
    const response = await axiosInstance.post("/institutional-affiliation", data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(
      `/institutional-affiliation/${id}`,
      data
    );
    return response.data;
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(
      `/institutional-affiliation/${id}`
    );
    return response.data;
  },
};

export default institutionalAffiliationService;
